import { render } from "./image.vue?vue&type=template&id=0e2e7712"
import script from "./image.vue?vue&type=script&lang=js"
export * from "./image.vue?vue&type=script&lang=js"

import "./image.vue?vue&type=style&index=0&id=0e2e7712&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/FK-YF23001-01-生产-01-综合管理后台sznc_admin-前端构建部署/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__